/**
 * Los importes del programa de socios viajan en **céntimos enteros** (§23 de
 * CLAUDE.md): 1678 es $16,78. Aquí solo se pintan; las cuentas las hace el núcleo.
 */
const formato = new Intl.NumberFormat('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** `1678` → `$16,78`; los negativos, `-$3,00`. Lo que no es un número se pinta como cero. */
export const dolares = (centimos: number): string => {
  const entero = Number.isFinite(centimos) ? Math.round(centimos) : 0
  const signo = entero < 0 ? '-' : ''
  return `${signo}$${formato.format(Math.abs(entero) / 100)}`
}

/** `20` → `20 %`, con el espacio fino que pide el español. */
export const porcentaje = (valor: number): string => `${valor.toLocaleString('es')} %`
